import { DetailView } from '..'
import { withDetailView } from '../detail/Detail.view'

export const withTableView = (
  WrappedComponent: React.ComponentType<any>,
  title: string
) => {
  const Table = () => {
    return (
      <>
        <DetailView.Content>
          <WrappedComponent />
        </DetailView.Content>
      </>
    )
  }
  return function DetailViewWrapper(props: any) {
    return withDetailView(Table, title)(props)
  }
}
